import { OrganizationLevelPermissions } from 'src/app/models/organizationLevelPermissions';
import { RolePermissionObjects } from './rolePermissionObjects.constants';

export const devicesRouteConfig = [
    { routerLink: '/dashboard/devices/device', title: 'Devices', objectId: RolePermissionObjects.Sensor },
    { routerLink: '/dashboard/devices/calibration-equipment', title: 'Calibration Equipment', objectId: RolePermissionObjects.CalibrationEquipment },
    { routerLink: '/dashboard/devices/sampling-equipment', title: 'Sampling Equipment', objectId: RolePermissionObjects.SamplingEquipment },
];

export const getFilteredDevicesRouteConfig = (permissions: OrganizationLevelPermissions) => {
    if (!permissions?.canAccessIhModule) {
        return [{ routerLink: '/dashboard/devices/device', title: 'Devices', objectId: RolePermissionObjects.Sensor }];
    }
    return devicesRouteConfig;
};
